import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

import main from './main';


const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const swup = new Swup({
  plugins: [
    // new SwupBodyClassPlugin()
  ]
}); 

Alpine.plugin(intersect)


// Events
swup.on('contentReplaced', init);

// Start Apline after swup so it works correctly
window.Alpine = Alpine;

Alpine.data('main', main);

Alpine.start();


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍'); 
  window.scrollTo({
    top: 0,
    behavior: "instant"
  });
}